import { getVerboseHistoryFormattedTimestamp, getHistoryFormattedTimestamp
// @ts-expect-error module not typed
} from 'conversations-message-history/util/getHistoryFormattedTimestamp';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTimestamp = styled.span.withConfig({
  displayName: "MessageHeaderTimestamp__StyledTimestamp",
  componentId: "g6rkr-0"
})(["display:flex;flex-direction:row;align-items:center;margin-left:auto;font-size:12px;"]);
const MessageHeaderTimestamp = ({
  timestamp
}) => {
  const hourMinTimestamp = getHistoryFormattedTimestamp(timestamp);
  if (!hourMinTimestamp) return null;
  return /*#__PURE__*/_jsx(UITooltip, {
    title: getVerboseHistoryFormattedTimestamp(timestamp),
    children: /*#__PURE__*/_jsx(StyledTimestamp, {
      "data-test-vr-hidden": true,
      "data-test-id": "sender-header-content-timestamp",
      className: "is--text--help",
      children: hourMinTimestamp
    })
  });
};
MessageHeaderTimestamp.displayName = 'MessageHeaderTimestamp';
MessageHeaderTimestamp.propTypes = {
  // @ts-expect-error this is correct, typescript is displeased by it.  propTypes will be removed once all CommonMessage consumers are ts
  timestamp: PropTypes.number
};
export default MessageHeaderTimestamp;